module.exports = __webpack_public_path__ + "static/media/portal-app-icon.3203e697.svg";